import React from "react";
import { createRoot } from "react-dom/client";

import App from "./App";

// Rendering App
createRoot(document.getElementById("root")).render(<App />);
